import { imageUrl } from '@helpers/image';
import * as React from 'react';
import S from './VideoBanner.styles';
const VideoBanner = ({ images, videos }) => {
    if (!videos) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Video, { autoPlay: true, loop: true, muted: true, playsInline: true, poster: images && images.desktop ? imageUrl(images.desktop, { width: 1920 }) : undefined, "data-desktop": true },
            React.createElement("source", { type: videos.desktop.includes('webm') ? 'video/webm' : 'video/mp4', src: videos.desktop })),
        React.createElement(S.Video, { autoPlay: true, loop: true, muted: true, playsInline: true, poster: images && images.tablet ? imageUrl(images.tablet, { width: 1024 }) : undefined, "data-tablet": true },
            React.createElement("source", { type: videos.tablet.includes('webm') ? 'video/webm' : 'video/mp4', src: videos.tablet })),
        React.createElement(S.Video, { autoPlay: true, loop: true, muted: true, playsInline: true, poster: images && images.mobile ? imageUrl(images.mobile, { width: 768 }) : undefined, "data-mobile": true },
            React.createElement("source", { type: videos.mobile.includes('webm') ? 'video/webm' : 'video/mp4', src: videos.mobile }))));
};
export default VideoBanner;
